import React from 'react';
import {
  Wrapper,
  LoaderWrapper,
  CarIcon,
  AnimatedCircle,
  AnimatedCircleIEFallback
} from './styles/index';

type ILoadingSpinner = {
  isLarge?: boolean;
  hasPaddingTop?: boolean;
  isFullScreen?: boolean;
  className?: string;
};

const LoadingSpinner = ({
  isLarge = false,
  hasPaddingTop = false,
  isFullScreen = false,
  className = 'spinnerWrapper'
}: ILoadingSpinner) => (
  <Wrapper
    hasPaddingTop={hasPaddingTop}
    isFullScreen={isFullScreen}
    className={className}
  >
    <LoaderWrapper>
      <CarIcon isLarge={isLarge} viewBox={isLarge ? '0 0 29 29' : '0 0 22 22'}>
        {isLarge ? (
          <g>
            <path d="M14.5,2.25c5.4,0,6.24,1,6.27,1h0s-.84,1.07-6.27,1.07-6.24-1-6.27-1h0s.84-1.07,6.27-1.07M14.5,0C9.82,0,6,.73,6,3.31s3.82,3.3,8.5,3.3S23,5.88,23,3.31,19.18,0,14.5,0Z" />
            <path d="M28,17H26.17l-2.12-5.11A3.67,3.67,0,0,0,20.84,10H8.16A3.67,3.67,0,0,0,5,11.89L2.83,17H1a1,1,0,0,0,0,2H2v9a1,1,0,0,0,1,1H5a1,1,0,0,0,1-1V27H23v1a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V19h1a1,1,0,0,0,0-2ZM6.75,12.78A1.66,1.66,0,0,1,8.16,12H20.84a1.66,1.66,0,0,1,1.41.78L24,17H5ZM25,25H4V19H25Z" />
            <path d="M8,23h2a1,1,0,0,0,0-2H8a1,1,0,0,0,0,2Z" />
            <path d="M19,23h2a1,1,0,0,0,0-2H19a1,1,0,0,0,0,2Z" />
          </g>
        ) : (
          <g>
            <path d="M11,1.5c4.92,0,5.49,1,5.5,1v.06s-.58,1-5.5,1-5.49-1-5.5-1V2.47s.58-1,5.5-1M11,0C7.14,0,4,.56,4,2.5S7.14,5,11,5s7-.56,7-2.5S14.86,0,11,0Z" />
            <path d="M14.84,9a1.67,1.67,0,0,1,1.44.82L17.81,13H4.19L5.72,9.82A1.67,1.67,0,0,1,7.16,9h7.68m0-2H7.16A3.67,3.67,0,0,0,4,8.89L2,13H1a1,1,0,0,0,0,2v6H1a1,1,0,0,0,1,1H4a1,1,0,0,0,1-1H17a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1h0V15a1,1,0,0,0,0-2H20l-2-4.11A3.67,3.67,0,0,0,14.84,7ZM3,19V15H19v4H3Z" />
            <path d="M7,16H6a1,1,0,0,0,0,2H7a1,1,0,0,0,0-2Z" />
            <path d="M16,16H15a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z" />
          </g>
        )}
      </CarIcon>
      <AnimatedCircle isLarge={isLarge} viewBox="25 25 50 50">
        <circle
          className="path"
          cx="50"
          cy="50"
          r="20"
          fill="none"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
      </AnimatedCircle>
      <AnimatedCircleIEFallback isLarge={isLarge} />
    </LoaderWrapper>
  </Wrapper>
);

export default LoadingSpinner;
